import * as React from "react";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";

import { ContainerProps } from "../Container";

export const HotwireContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title,
  subHeadline,
}) => (
  <div
    className="HotwireCheckPrices"
    id={id}
    data-fm={fmId}
    data-fm-title-id={fmTitleId}
    data-module="last-minute-deals"
  >
    <UitkSpacing padding={{ block: "three" }}>
      <>
        <UitkSpacing padding={{ block: "four" }}>
          <UitkHeading tag="h2" size={4}>
            {title}
          </UitkHeading>
          {subHeadline && (
            <UitkSpacing margin={{ blockstart: "one" }}>
              <UitkText size={300} weight="regular">
                {subHeadline}
              </UitkText>
            </UitkSpacing>
          )}
        </UitkSpacing>
        {children}
      </>
    </UitkSpacing>
  </div>
);
